// extracted by mini-css-extract-plugin
module.exports = {"address":"_2wFMSUosYQ7x3hr4vqTcpB"};